import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  name: 'Scrollbar',
  props: {
    settings: {
      type: Object,
      default: () => ({})
    }
  },
  components: {
    VuePerfectScrollbar
  },
  methods: {
    update() {
      this.$refs.scrollbar.update()
    }
  }
}